import React from "react";
import PropTypes from "prop-types";
import "./SpeedIndicator.css";

const VSpeedsLegend = ({
  vSpeeds,
  onItemClick,
  onItemMouseMove,
  onItemMouseLeave,
}) => {
  return (
    <div className="v-speeds-legend">
      <h4>PA-28 V-Speeds</h4>
      <div className="v-speeds-grid">
        {vSpeeds.map(({ speed, label, color, description }) => (
          <div
            key={label}
            className="v-speed-item"
            onClick={(e) => onItemClick(e, description)}
            onMouseLeave={onItemMouseLeave}
            onMouseMove={onItemMouseMove}
          >
            <span
              className="v-speed-color"
              style={{ backgroundColor: color }}
            ></span>
            <span className="v-speed-label">{label}</span>
            <span className="v-speed-value">{speed} kt</span>
          </div>
        ))}
      </div>
    </div>
  );
};

VSpeedsLegend.propTypes = {
  vSpeeds: PropTypes.array.isRequired,
  onItemClick: PropTypes.func,
  onItemMouseMove: PropTypes.func,
  onItemMouseLeave: PropTypes.func,
};

VSpeedsLegend.defaultProps = {
  onItemClick: () => {},
  onItemMouseMove: () => {},
  onItemMouseLeave: () => {},
};

export default VSpeedsLegend;
